<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Layouts de Autobus</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showCreateModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Layout de Autobus</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>

              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="search"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="status"
                placeholder="Seleccionar status"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Activo/Inactivo"
                  value="Activo/Inactivo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Activo"
                  value="Activo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Inactivo"
                  value="Inactivo"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="layouts"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="layouts">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Nombre" prop="attributes.nombre" />
              <el-table-column label="Asientos">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.numero_asientos">{{row.attributes.numero_asientos}}</span>
                  <span v-else>Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="Niveles">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.niveles">{{row.attributes.niveles}}</span>
                  <span v-else>Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="Atributos">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.atributos">
                    <span v-for="atributo in JSON.parse(row.attributes.atributos)" :key="atributo.id">{{atributo.nombre}}<br></span>
                  </div>
                  <div v-else>
                    <span>Pendiente</span>
                  </div>
                </div>
              </el-table-column>
              <el-table-column label="Usado en corridas">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.usado_en_corridas === 0">No</span>
                  <span v-else>Si</span>
                </div>
              </el-table-column>
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editLayout(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.usado_en_corridas === 0" class="hover-apolo" type="primary" icon size="sm" @click="designLayout(row)">
                    <span class="btn-inner--text">Editar Diseño</span>
                  </base-button>
                  <base-button v-else class="hover-apolo" type="primary" icon size="sm" @click="designLayout(row)">
                    <span class="btn-inner--text">Ver Diseño</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateLayout(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateLayout(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear layout autobus</h6>
        <form class="new-event--form" @submit.prevent="addLayout">
          <base-input label="Nombre"
                      placeholder="Nombre del layout"
                      v-model="layout.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addLayout">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar layout autobus</h6>
        <form class="new-event--form" @submit.prevent="editLayout">
          <base-input label="Nombre"
                      placeholder="Nombre del layout"
                      v-model="layout.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateLayout">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <modal-design-layout v-if="showDesignLayoutModal" :showDesignLayoutModal="showDesignLayoutModal" :layout="layout" @event="getList"/>
    </div>
  </template>
  <script>
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ModalDesignLayout from "@/views/Gestion/LayoutsAutobus/ModalDesignLayout.vue";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";

  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Modal,
      ModalDesignLayout,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        layouts: [],
        selectedRows: [],

        showDesignLayoutModal: false,

        externo: null,
        status: null,
        search: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 layouts por página'},
          {value:'10', descripcion: '10 layouts por página'},
          {value:'25', descripcion: '25 layouts por página'},
          {value:'50', descripcion: '50 layouts por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        layout: {
          type: "layout",
          nombre: null
        }
      };
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      search: {
        handler: "getListDebounced",
        immediate: true,
      },
      externo: {
        handler: "getListDebounced",
        immediate: true,
      },
      status: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
  
    methods: {
      showCreateModal(){
        this.showAddModal = true;
        this.layout.nombre = null;
      },
      designLayout(row){
        this.layout = row;
        this.layout.nombre = row.attributes.nombre;
        this.layout.id = row.id;
        this.layout.attributes = row.attributes;
        this.layout.categorias = row.categorias;
        this.showDesignLayoutModal = true;
        let documentClasses = document.body.classList;
        documentClasses.add("modal-open");
      },
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        this.showDesignLayoutModal = false;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.search ? { nombre: this.search } : {}),
            ...(this.externo ? { externo: this.externo } : {}),
            ...(this.status ? { status: this.status } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("layouts/list", params).then(() => {
          this.layouts = this.$store.getters["layouts/list"];
          this.total = this.$store.getters["layouts/listTotal"];
        });
        this.loading = false;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.layout.nombre = null;
      },

      async addLayout(){
        try {
        await this.$store.dispatch("layouts/add", this.layout);

        this.$notify({
          type: "success",
          message: "Layout creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editLayout(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.layout.nombre = row.attributes.nombre;
        this.layout.id = row.id;
      },

      async updateLayout() {
        try{
          await this.$store.dispatch("layouts/update", this.layout);
          this.$notify({
            type: "success",
            message: "Layout actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
      
      async activateLayout(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este layout?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("layouts/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Layout activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateLayout(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este layout?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("layouts/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Layout desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>